import { makeAutoObservable } from "mobx";
import { Auth } from 'aws-amplify';
import history from '../authentication/History';
import { toast } from 'react-toastify';
import environment from '../environments';

class StickerStore {  
  constructor() {
    makeAutoObservable(this);
  }

    stickerList = [];
    stickerMap = [];
    stickerLocations = [];
    stickerPhotos = [];
    selectedLocation = {
      lat: 0,
      lon: 0
    }
    sticker = {
      landingpageInputs: [],
      landingpageValues: []
    }
    stickerPhotos = [];

    start = 0;
    limit = 999999;

    uploadingPhoto = false;

    /* Endpoints */
    detailRoute = "/stickers";
    dataEndpoint = environment.API_HOST + "/stickers/list";
    searchEndpoint = environment.API_HOST + "/stickers/search";

    /* Table configuration */
    sortBy = "scans";
    sortOrder = "desc";
    tableColumns = [
        {name: "ID", field: "identifier", sortable: true}, 
        //{name: "Titel", field: "title"},
        //{name: "URL", field: "url"},
        {name: "Anzahl Scans", field: "scans", type: "text", sortable: true},
        {name: "Erstellt am", field: "created", type: "date", sortable: true},
        {name: "Aktualisiert am", field: "updated", type: "date", sortable: true},
        {name: "Zugeordnet am", field: "assigned", type: "date", sortable: true},
        {name: "Produkt", field: "icon", type: "image", sortable: false}
    ];

    /* Sharing */
    shareModalOpen = false;
    shareUrl = "";

    /* Photo */
    photoModalOpen = false;
    photoUrl = "";

    /* Unassignment */
    unassignModalOpen = false;

    /* Details */
    detailsModalOpen = false;

    validateReponse(response) {
      return new Promise(function(resolve, reject) {
        if (response.status === 403) {
          response.json()
          .then((json) => {
            history.push("/terms")
            reject(json.message)
          })
        } else if (response.status === 400) {
          response.json()
          .then((json) => {
            if (json.message.error.code) {
              switch(json.message.error.code) {
                case 509012:
                  reject("Dieser Sticker ist bereits einem Benutzer zugeordnet.");
                  break;
                default:
                  reject("Es ist ein Fehler aufgetreten.")
                  break;
              }
            } else {
              reject("Es ist ein Fehler aufgetreten.")
            }
          })
        } else {
          resolve(response)
        }
      })
    }
  
    getStickerList() {
        Auth.currentSession()
        .then((token) => {
            fetch(this.dataEndpoint + "?start=" + this.start + "&limit=" + this.limit + "&sortBy=" + this.sortBy + "&sortOrder=" + this.sortOrder, {
                headers: {
                    Authorization: "Bearer " + token.getAccessToken().getJwtToken()
                }
            })
            .then((response) => this.validateReponse(response))
            .then((response) => response.json())
            .then((json) => {
                this.stickerList = json.data
            })
            .catch((error) => {
                console.log(error);
                return error;
            })
        })
        .catch((error) => {
            console.log(error);
            return error;
        })
    }

    getStickerMap() {
      Auth.currentSession()
      .then((token) => {
          fetch(environment.API_HOST + "/stickers/map", {
              headers: {
                  Authorization: "Bearer " + token.getAccessToken().getJwtToken()
              }
          })
          .then((response) => this.validateReponse(response))
          .then((response) => response.json())
          .then((json) => {
              this.stickerMap = json.data
          })
          .catch((error) => {
              console.log(error);
              return error;
          })
      })
      .catch((error) => {
          console.log(error);
          return error;
      })
    }

    searchSticker() {
        if (this.searchTerm && this.searchTerm.length > 0) {
            Auth.currentSession()
            .then((token) => {
                fetch(this.searchEndpoint + "?term=" + this.searchTerm, {
                    headers: {
                        Authorization: "Bearer " + token.getAccessToken().getJwtToken()
                    }
                })
                .then((response) => this.validateReponse(response))
                .then((response) => response.json())
                .then((json) => {
                    this.stickerList = json.data
                })
                .catch((error) => {
                    console.log(error);
                })

            })
            .catch((error) => {
                console.log(error);
                return error;
            })
        } else {
            this.getStickerList();
        }
    }

    getSticker(id) {
        Auth.currentSession()
        .then((token) => {
            fetch(environment.API_HOST + "/stickers/" + id, {
                headers: {
                  Authorization: "Bearer " + token.getAccessToken().getJwtToken()
                }
              })
              .then((response) => this.validateReponse(response))
              .then((response) => response.json())
              .then((json) => {
                if (json.data[0]) {
                  this.sticker = json.data[0];
                } else {
                  history.push('/stickers')
                }
              })
              .catch((error) => {
                console.log(error);
              })
        })
        .catch((error) => {
            console.log(error);
            return error;
        })
    }

    saveSticker(id) {
        Auth.currentSession()
        .then((token) => {
            var payload = {
                title: this.sticker.title,
                active: this.sticker.active,
                url: this.sticker.url,
                lp_active: this.sticker.lp_active,
                landingpageValues: this.sticker.landingpageValues
            }
        
            payload = JSON.stringify(payload);
        
            fetch(environment.API_HOST + "/stickers/" + id, {
              method: 'PUT',
              headers: {
                "Authorization": "Bearer " + token.getAccessToken().getJwtToken(),
                "Content-Type": "application/json"
              },
              body: payload
            })
            .then((response) => this.validateReponse(response))
            .then((response) => response.json())
            .then((json) => { 
              toast.success("Sticker erfolgreich gespeichert.");
              this.getSticker(id);
            })
            .catch((error) => {
              toast.error(String(error));
              console.log(error);
            })
        })
        .catch((error) => {
            console.log(error);
            return error;
        })
    }

    assignSticker(identifier, key) {
        Auth.currentSession()
        .then((token) => {
            fetch(environment.API_HOST + "/stickers/assign?identifier=" + identifier + "&key=" + (key || ""), {
              method: 'POST',
              headers: {
                "Authorization": "Bearer " + token.getAccessToken().getJwtToken(),
                "Content-Type": "application/json"
              }
            })
            .then((response) => this.validateReponse(response))
            .then((response) => response.json())
            .then((json) => { 
              toast.success("Sticker erfolgreich hinzugefügt.");
              if (json.data.next) {
                history.push('stickers/' + json.data.next)
              } else {
                history.push('/stickers')
              }
            })
            .catch((error) => {
              toast.error(String(error));
              console.log(error);
            })
        })
        .catch((error) => {
            console.log(error);
            return error;
        })
    }

    shareSticker(id) {
        /* Disabled 2019-11-25 */
        /*
        Auth.currentSession()
        .then((token) => {
            fetch(environment.API_HOST + "/stickers/" + id + "/share", {
              method: 'GET',
              headers: {
                "Authorization": "Bearer " + token.getAccessToken().getJwtToken(),
                "Content-Type": "application/json"
              }
            })
            .then((response) => this.validateReponse(response))
            .then((response) => response.json())
            .then((json) => { 
              this.shareUrl = environment.DELIVERY_HOST + "/" + json.data[0].identifier + "?key=" + json.data[0].share_key;
              this.shareModalOpen = true;
            })
            .catch((error) => {
              toast.error(String(error));
              console.log(error);
            })
        })
        .catch((error) => {
            console.log(error);
            return error;
        })
        */
    }
    
    unassignSticker(id) {
      Auth.currentSession()
      .then((token) => {
          fetch(environment.API_HOST + "/stickers/" + id, {
            method: 'DELETE',
            headers: {
              "Authorization": "Bearer " + token.getAccessToken().getJwtToken(),
              "Content-Type": "application/json"
            }
          })
          .then((response) => this.validateReponse(response))
          .then((response) => response.json())
          .then((json) => { 
            this.unassignModalOpen = false;
            // toast.success("Sticker erfolgreich gelöscht.");
            history.push('/stickers')
          })
          .catch((error) => {
            toast.error(String(error));
            console.log(error);
          })
      })
      .catch((error) => {
          console.log(error);
          return error;
      })
  }

    getStickerLocations(id) {
      Auth.currentSession()
      .then((token) => {
          fetch(environment.API_HOST + "/stickers/" + id + "/locations", {
              headers: {
                Authorization: "Bearer " + token.getAccessToken().getJwtToken()
              }
            })
            .then((response) => this.validateReponse(response))
            .then((response) => response.json())
            .then((json) => {
              this.stickerLocations = json.data;
              this.selectedLocation = {
                lat: this.stickerLocations[0].lat,
                lon: this.stickerLocations[0].lon
              }
            })
            .catch((error) => {
              console.log(error);
            })
      })
      .catch((error) => {
          console.log(error);
          return error;
      })
    }

    addStickerLocation(id) {
      Auth.currentSession()
      .then((token) => {

        if (navigator && navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(pos => { 
            const coords = pos.coords; 
            var payload = {
              lat: coords.latitude,
              lon: coords.longitude
            }

            payload = JSON.stringify(payload);

            fetch(environment.API_HOST + "/stickers/" + id + "/locations", {
              method: 'PUT',
              headers: {
                "Authorization": "Bearer " + token.getAccessToken().getJwtToken(),
                "Content-Type": "application/json"
              },
              body: payload
            })
            .then((response) => this.validateReponse(response))
            .then((response) => response.json())
            .then((json) => { 
              toast.success("Standort erfolgreich gespeichert.");
              this.getStickerLocations(id);
            })
            .catch((error) => {
              toast.error(String(error));
              console.log(error);
            })
         }); 
        }
      })
      .catch((error) => {
          console.log(error);
          return error;
      })
    }

    deleteStickerLocation(id, uuid) {
      Auth.currentSession()
      .then((token) => {
          fetch(environment.API_HOST + "/stickers/" + id + "/locations/" + uuid, {
            method: 'DELETE',
            headers: {
              "Authorization": "Bearer " + token.getAccessToken().getJwtToken(),
              "Content-Type": "application/json"
            }
          })
          .then((response) => this.validateReponse(response))
          .then((response) => response.json())
          .then((json) => { 
            toast.success("Standort erfolgreich gelöscht.");
            this.getStickerLocations(id);
          })
          .catch((error) => {
            toast.error(String(error));
            console.log(error);
          })
      })
      .catch((error) => {
          console.log(error);
          return error;
      })
    }

    getStickerPhotos(id) {
      Auth.currentSession()
      .then((token) => {
          fetch(environment.API_HOST + "/stickers/" + id + "/photos", {
              headers: {
                Authorization: "Bearer " + token.getAccessToken().getJwtToken()
              }
            })
            .then((response) => this.validateReponse(response))
            .then((response) => response.json())
            .then((json) => {
              this.stickerPhotos = json.data;
            })
            .catch((error) => {
              console.log(error);
            })
      })
      .catch((error) => {
          console.log(error);
          return error;
      })
    }

    setStickerFavorite(id, uuid) {
      Auth.currentSession()
      .then((token) => {
          fetch(environment.API_HOST + "/stickers/" + id + "/photos/" + uuid, {
              method: "PUT",
              headers: {
                Authorization: "Bearer " + token.getAccessToken().getJwtToken()
              }
            })
            .then((response) => this.validateReponse(response))
            .then((response) => response.json())
            .then((json) => {
              toast.success("Foto erfolgreich als Favorit merkiert.");
              this.getStickerPhotos(id);
            })
            .catch((error) => {
              console.log(error);
            })
      })
      .catch((error) => {
          console.log(error);
          return error;
      })
    }

    addStickerPhoto(id, photo) {
      this.uploadingPhoto = true;
      Auth.currentSession()
      .then((token) => {
          var data = new FormData();
          data.append("File", photo);
          fetch(environment.API_HOST + "/stickers/" + id + "/photos", {
              method: "POST",
              headers: {
                Authorization: "Bearer " + token.getAccessToken().getJwtToken()
              },
              body: data
            })
            .then((response) => this.validateReponse(response))
            .then((response) => response.json())
            .then((json) => {
              this.uploadingPhoto = false;
              toast.success("Foto erfolgreich hochgeladen.");
              this.getStickerPhotos(id);
            })
            .catch((error) => {
              this.uploadingPhoto = false;
              console.log(error);
            })
      })
      .catch((error) => {
          this.uploadingPhoto = false;
          console.log(error);
          return error;
      })
    }

    deleteStickerPhoto(id, uuid) {
      Auth.currentSession()
      .then((token) => {
          fetch(environment.API_HOST + "/stickers/" + id + "/photos/" + uuid, {
              method: "DELETE",
              headers: {
                Authorization: "Bearer " + token.getAccessToken().getJwtToken()
              }
            })
            .then((response) => this.validateReponse(response))
            .then((response) => response.json())
            .then((json) => {
              toast.success("Foto erfolgreich gelöscht.");
              this.getStickerPhotos(id);
            })
            .catch((error) => {
              console.log(error);
            })
      })
      .catch((error) => {
          console.log(error);
          return error;
      })
    }

    sort(column) {
        this.sortBy = column;

        if (this.sortOrder === 'asc') {
            this.sortOrder = 'desc';
        } else {
            this.sortOrder = 'asc';
        }

        this.getStickerList();
    }

    nextPage() {
        this.start = this.start + this.limit
        this.getStickerList();
    }

    previousPage() {
        if (this.start - this.limit >= 0) {
            this.start = this.start - this.limit
            this.getStickerList();
        }
    }
  }

  const stickerStore = new StickerStore();
  export default stickerStore;